import { ff } from '@atlassian/jira-feature-flagging';

// <itsm-grimlock>
export const isJsmSmartRequestSummaryEnabled = () =>
	ff('enable-jsm-smart-request-summary_kva1r', false);
// </itsm-grimlock>
